import styled from '@emotion/styled';
import { ICONS } from '../../../ui-kit/icons';

export const TextInputIcon = styled(ICONS.EDIT)`
  fill: ${(p) => p.theme.palette.primary.black};
`;
